module.exports = __webpack_public_path__ + "img/coins2-green.84408ee8.svg";